import { createFileRoute } from "@tanstack/react-router";
import { Diagnostic1822 } from "@/components/diagnostic/Diagnostic1822";
import type { Lang1822 } from "@/lib/reports1822";

export const Route = createFileRoute("/diag1822")({
  validateSearch: (search: Record<string, unknown>): { lang?: Lang1822 } => ({
    lang:
      search.lang === "az" || search.lang === "en" || search.lang === "ru"
        ? (search.lang as Lang1822)
        : undefined,
  }),
  head: () => ({
    meta: [{ title: "Диагностика 18–22 — Yolutap" }, { name: "robots", content: "noindex" }],
  }),
  component: Diagnostic1822,
});
